import React, {useEffect} from 'react';
import cx from 'classnames';
import s from './CartApp.scss';
import {CartBody} from './partials/CartBody';
import {EmptyState} from '../Components/EmptyState/EmptyState';
import {useControllerProps} from '../ControllerContext';
import {withResizeObserver} from './HOC/withResizeObserver';
import {withSentryErrorBoundary} from '@wix/native-components-infra';
import {CART_DSN} from '@wix/wixstores-client-storefront-sdk';

export enum CartAppDataHook {
  root = 'CartAppDataHook.root',
}

const CartApp = () => {
  const {isResponsive} = useControllerProps();
  const {shouldRenderEmptyState} = useControllerProps().cartStore;
  const {handlePaymentMethodError} = useControllerProps().cashierExpressStore;
  const viewerVersion = isResponsive ? 'viewer_x' : 'viewer_classic';
  const classNames = cx(s.main, s[viewerVersion]);

  useEffect(() => {
    handlePaymentMethodError();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={s.container}>
      <main data-hook={CartAppDataHook.root} className={classNames}>
        {shouldRenderEmptyState ? <EmptyState /> : <CartBody />}
      </main>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default withSentryErrorBoundary(withResizeObserver(CartApp), {
  dsn: CART_DSN,
  config: {environment: 'Native Component'},
});
